import { render, staticRenderFns } from "./ServicePageInfoProc.vue?vue&type=template&id=549538e1"
import script from "./ServicePageInfoProc.vue?vue&type=script&lang=js"
export * from "./ServicePageInfoProc.vue?vue&type=script&lang=js"
import style0 from "./ServicePageInfoProc.vue?vue&type=style&index=0&id=549538e1&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports